import { initializeApp } from "firebase/app";
// import {
//   getAnalytics
//   //   logEvent, setUserProperties
// } from "firebase/analytics";
import {
  getRemoteConfig,
  getValue,
  fetchAndActivate,
  setLogLevel
} from "firebase/remote-config";
import environment from "src/utils/environment";
import rcDefaults from "./remote_config_defaults.json";

// const log = window.require("electron-log");

const firebaseConfig = {
  apiKey: "AIzaSyB493Xqj3oLh95Nb2PjIY3lt2_f2MSRZvY",
  authDomain: "barkio-368e6.firebaseapp.com",
  databaseURL: "https://barkio-368e6.firebaseio.com",
  projectId: "barkio-368e6",
  storageBucket: "barkio-368e6.appspot.com",
  messagingSenderId: "673704537567",
  appId: "1:673704537567:web:7816b863bfd93c6dc8686a",
  measurementId: "G-3FGBWFLGS3"
};

const app = initializeApp(firebaseConfig);
const remoteConfig = getRemoteConfig(app);
// const analytics = getAnalytics(app);
// getAnalytics(app);

if (environment.debugMode) setLogLevel(remoteConfig, "debug");
remoteConfig.defaultConfig = rcDefaults;

function convertValue(val) {
  if (val === "true" || val === "false") return val === "true";
  else if (!isNaN(val)) return Number(val);
  else return val;
}

export async function initRemoteConfig() {
  await fetchAndActivate(remoteConfig);
}

export function getRemoteConfigValue(key) {
  const { _value } = getValue(remoteConfig, key);
  return convertValue(_value);
}

// setUserProperties(analytics, {
//   app_environment: environment.isBrowser ? "browser" : "electron"
// });
// logEvent(analytics, "app_launched");
